import React, { useEffect, useState } from 'react';
import { EditableFieldProps } from '../types';

const EditableField: React.FC<EditableFieldProps> = ({
  value: propValue,
  onChange,
  fieldKey,
  multiline = false,
  placeholder = '',
  className = ''
}) => {
  const [value, setValue] = useState(propValue);
  
  // Cargar valor guardado de localStorage al montar
  useEffect(() => {
    const saved = localStorage.getItem(`informe_cip_${fieldKey}`);
    if (saved && !propValue) {
      setValue(saved);
      onChange?.(saved);
    }
  }, [fieldKey]);

  // Actualizar estado interno cuando cambia el prop
  useEffect(() => {
    setValue(propValue);
  }, [propValue]);

  const handleChange = (newValue: string) => {
    setValue(newValue);
    onChange?.(newValue);
    localStorage.setItem(`informe_cip_${fieldKey}`, newValue);
  };

  if (multiline) {
    return (
      <textarea
        className={`field block ${className}`}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        data-key={fieldKey}
      />
    );
  }

  return (
    <input
      type="text"
      className={`field ${className}`}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      placeholder={placeholder}
      data-key={fieldKey}
    />
  );
};

export default EditableField;
